export const NotificationButtons = {
    YES: "YES",
    NO: "NO",
    OK: "OK",
    CANCEL: "CANCEL"
}